import {
  bufferCount,
  combineLatest,
  EMPTY,
  MonoTypeOperatorFunction,
  Observable,
  of,
  toArray,
} from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

export type ObservableResult<T> =
  T extends Observable<infer ReturnType> ? ReturnType : never;

export const nonEmptyValue$: Observable<null> = of(null);

export function chunkOperations<T>(
  operations: Observable<T>[],
  chunkCount = 10,
) {
  return of(...operations).pipe(
    bufferCount(chunkCount),
    concatMap((op) => combineLatest(op)),
    toArray(),
    catchError(() => EMPTY),
  );
}

export const concatTap = <T>(
  operation: (value: T) => Observable<unknown> | null | undefined,
): MonoTypeOperatorFunction<T> =>
  concatMap((value) => {
    const result = operation(value);
    if (!result) {
      return of(value);
    }
    return result.pipe(map(() => value));
  });
